var styles = {"Field":"gKEs5OtPqUE-","Checkbox":"OJSsAySjqU0-","Label":"_8CD-gVt024Q-","showCheck":"V9SECR5ULsA-","hideCheck":"_2tIlaETSias-","error":"RTPa94lzLk0-"};

export { styles as default };
//# sourceMappingURL=InputCheckbox.module.css.js.map
